import { Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import GlobalAvailabilityWidget, {
  OpenerProps,
} from '../DatesPicker/GlobalAvailabilityWidget';
import EventIcon from '@mui/icons-material/Event';
interface NoDeparturesProps {
  DepartureDateFilterOpener: React.FC<OpenerProps>;
}
const NoDeparturesWidget: React.FC<NoDeparturesProps> = ({
  DepartureDateFilterOpener,
}) => {
  return (
    <Stack
      padding={3}
      sx={{ backgroundColor: '#E6FBFF', width: '100%', borderRadius: '4px' }}
    >
      <Typography variant="Body M bold" display="flex">
        <EventIcon sx={{ fontSize: '24px' }} />
        Oops! No departures match your availability...
      </Typography>
      <Box display="flex" flexWrap="wrap" gap="4px" alignItems="flex-end">
        <Typography variant="Body S">
          but there are 147 other departures planned — try
        </Typography>
        <Typography
          variant="Body S bold"
          sx={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          <GlobalAvailabilityWidget
            Opener={(props) => {
              return (
                <DepartureDateFilterOpener
                  {...props}
                  label={' expanding your availability'}
                  isOpen={true}
                  icon={null}
                />
              );
            }}
          />
        </Typography>
      </Box>
    </Stack>
  );
};
export default NoDeparturesWidget;
